export default {
  "input": "_input_d3lzg1"
};